import { render, staticRenderFns } from "./DocumentTypeForm.vue?vue&type=template&id=0dfd5240&scoped=true&"
import script from "./DocumentTypeForm.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeForm.vue?vue&type=style&index=0&id=0dfd5240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfd5240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dfd5240')) {
      api.createRecord('0dfd5240', component.options)
    } else {
      api.reload('0dfd5240', component.options)
    }
    module.hot.accept("./DocumentTypeForm.vue?vue&type=template&id=0dfd5240&scoped=true&", function () {
      api.rerender('0dfd5240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LMSGiframe/components/DocumentTypeForm.vue"
export default component.exports